/**
 * Raised when an explicitly configured local interpreter budget is exhausted.
 *
 * This is deliberately distinct from ScriptEvaluationError: exhausting a
 * caller-supplied resource budget does not prove that a script is invalid.
 */
export default class ScriptResourceLimitError extends Error {
    resource;
    limit;
    attempted;
    constructor(resource, limit, attempted) {
        const labels = {
            stack: 'Stack memory usage',
            'alt-stack': 'Alt stack memory usage',
            'element-size': 'Script element allocation'
        };
        const label = labels[resource];
        super(`${label} has exceeded ${limit} bytes`);
        this.resource = resource;
        this.limit = limit;
        this.attempted = attempted;
        this.name = 'ScriptResourceLimitError';
    }
}
//# sourceMappingURL=ScriptResourceLimitError.js.map